//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DEVICE, LANGUAGE } from "../../../store/mutation-types";
import store from "../../../store/index";
import { mapGetters } from "vuex";

export default {
  name: "LoginVerifyInstagramUserModalComponent",
  computed: {
    ...mapGetters({
      language: LANGUAGE,
    }),
    isIos() {
      return store.getters[DEVICE] === "ios";
    },
    /**
     * this was me 提示加粗
     */
    isMeBold() {
      return `<span style="font-weight: 600">${this.$t(
        "activePage.verifyLoginInsBtn"
      )}</span>`;
    },
    local() {
      // 获取当前国际化语言
      let local = this.language.toUpperCase();
      // 如果有 - 分割则截取后2位，
      const splitIndex = local.indexOf("-");
      if (splitIndex !== -1) {
        local = local.substr(splitIndex + 1);
      }
      return {
        "background-image": `url('../../../../static/images/active/This_was_me/Verify Login_${local}@3x.png')`,
      };
    },
  },
  model: {
    prop: "show",
    event: "updateShow",
  },
  props: {
    // 是否显示已做v-model
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: this.show,
    };
  },
  methods: {
    /**
     * 打开instagram
     */
    open() {
      window.location.href = "instagram://";
      this.showModal = false;
    },
  },
  watch: {
    showModal(val) {
      this.$emit("updateShow", val);
    },
    show(val) {
      this.showModal = val;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/login/verify_instagram_user_modal/Index.vue